import dayjs from "dayjs";
import type React from "react";
import { useCallback, useState } from "react";
import type { DeliveryHistory } from "../../../../hooks/useDeliveryHistoriesRestApi";
import type { DeliveryOpenRateAnalyticsResponse } from "../../../../utils/open-rate-utils";
import { DeliveryHistoriesModal } from "../DeliveryHistoriesModal";
import { DeliveryHistoriesItemUI } from "./DeliveryHistoriesItem";

export type DeliveryHistoriesTableUIProps = {
  deliveryHistories: DeliveryHistory[];
  openRates: DeliveryOpenRateAnalyticsResponse;
  openRatesLoaded: boolean;
  onResend: (history: DeliveryHistory) => void;
};

export const DeliveryHistoriesTableUI: React.VFC<
  DeliveryHistoriesTableUIProps
> = ({ deliveryHistories, openRates, openRatesLoaded, onResend }) => {
  const [selectedHistory, setSelectedHistory] =
    useState<DeliveryHistory | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleSelectHistory = useCallback((history: DeliveryHistory) => {
    setSelectedHistory(history);
    setIsModalVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalVisible(false);
    setSelectedHistory(null);
  }, []);

  const sortedHistories = [...deliveryHistories].sort(
    (a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf(),
  );

  return (
    <div className="overflow-x-auto">
      <table className="divide-y divide-gray-200 text-xs w-full">
        <thead className="bg-primary">
          <tr className="text-left font-medium text-white uppercase tracking-wider">
            <th className="px-3 py-2" style={{ width: "23.18%" }}>
              件名
            </th>
            <th className="px-3 py-2" style={{ width: "14.38%" }}>
              成功／失敗（成功数／配信数）
            </th>
            <th className="px-3 py-2" style={{ width: "14.38%" }}>
              開封率（開封数／配信数）
            </th>
            <th className="px-3 py-2" style={{ width: "9.61%" }}>
              配信種別
            </th>
            <th className="px-3 py-2" style={{ width: "9.61%" }}>
              配信者
            </th>
            <th className="px-3 py-2" style={{ width: "17.94%" }}>
              配信日時
            </th>
            <th className="px-3 py-2" style={{ width: "10.91%" }}>
              再配信
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {sortedHistories.map(deliveryHistory => (
            <DeliveryHistoriesItemUI
              key={deliveryHistory.id}
              deliveryHistory={deliveryHistory}
              openRate={
                deliveryHistory.deliveryId
                  ? openRates[deliveryHistory.deliveryId]
                  : undefined
              }
              openRatesLoaded={openRatesLoaded}
              onResend={onResend}
              onSelectHistory={() => handleSelectHistory(deliveryHistory)}
            />
          ))}
        </tbody>
      </table>

      {selectedHistory && (
        <DeliveryHistoriesModal
          visibility={isModalVisible}
          selectedHistory={selectedHistory}
          onResend={onResend}
          onClosed={closeModal}
          openRate={
            selectedHistory.deliveryId
              ? openRates[selectedHistory.deliveryId]
              : undefined
          }
          openRatesLoaded={openRatesLoaded}
        />
      )}
    </div>
  );
};
